import { FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage } from '@/components/shadcn/form'
import { Slider } from '@/components/shadcn/slider'
import { BaseFieldProps } from './types'
import { DocumentationButton } from './DocumentationButton'

export const SliderField: React.FC<BaseFieldProps> = ({ field, formFieldName, control }) => {
  return (
    <FormField
      control={control}
      name={formFieldName}
      render={({ field: formField }) => (
        <FormItem className="flex flex-1 flex-col">
          <div className="flex justify-start gap-2">
            <FormLabel>{field.title}</FormLabel>
            <DocumentationButton documentation={field.documentation} />
          </div>
          <FormDescription className="text-xs">{field.description}</FormDescription>
          <FormControl>
            <div className="space-y-2">
              <Slider
                min={field.minimum || 0}
                max={field.maximum || 100}
                step={1}
                value={[(formField.value as number) || 0]}
                onValueChange={([value]) => formField.onChange(value)}
                disabled={field.readOnly}
              />
              <div className="pr-5 text-right text-sm text-muted-foreground">Value: {formField.value as number}</div>
            </div>
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  )
}
